import React from "react";

import { getControlId } from "utils/utils";

import { DupontTooltip } from "components/DupontTooltip";

import "./index.scss";

export default function DupontIconButton(props) {
  let { id, name, active, tooltip, disabled, onClick, customClass, children, isRemove } = props;
  customClass = customClass || "";
  const type = disabled ? "disabled" : "primary";
  const btnId = id || name || getControlId(tooltip, "btn");

  const getBtnClass = () => {
    let btnClasses = isRemove ? "dupont-icon-btn-remove" : "dupont-icon-btn";
    btnClasses = active ? `${btnClasses} dupont-icon-btn--active` : btnClasses;
    btnClasses = customClass ? `${btnClasses} ${customClass}` : btnClasses;
    return btnClasses;
  };

  const btnClickHandler = event => {
    if (onClick) onClick(event);
    //This is added to avoid row click handler, when clicking on checkbox
    window.isTableCellAction = true;
    setTimeout(() => (window.isTableCellAction = false));
  };

  return (
    <DupontTooltip type={type} title={tooltip || ""}>
      <div>
        <button id={btnId} name={name} className={getBtnClass()} disabled={disabled} onClick={btnClickHandler}>
          {isRemove && <div className="cancel__container">{children}</div>}
          {!isRemove && children}
          {/* Keeping this code for future Use
              {tooltip && <span className="dupont-icon-btn--tooltip">{tooltip}</span>} 
          */}
        </button>
      </div>
    </DupontTooltip>
  );
}
